var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":12}},[_c('v-text-field',{attrs:{"readonly":"","label":_vm.$t('Link'),"value":_vm.value,"hide-details":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }